import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar,Tooltip, OverlayTrigger, Popover} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import store from "store2";
import FolderLookup from "../../components/Form/FolderLookup";


export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			const files = row.files.map(file => {
				const tooltip = <Tooltip id="file">{file.title}</Tooltip>
				return (
					<OverlayTrigger key={file.id} placement="top" overlay={tooltip}>
						<a style={{color:'#000', float:'right'}} href={'/file/download/' + file.id}>
							<i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip" />
						</a>
					</OverlayTrigger>
				)
			});
			return <div>
				<a href={'/document/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>
			</div>
		};

		const rendererFiles = (val, row) => {
			const files = row.files.map(file => {
				const tooltip = <Tooltip id="file">{file.title}</Tooltip>
				return (
					<OverlayTrigger key={file.id} placement="top" overlay={tooltip}>
						<a style={{color:'#000'}} href={'/file/download/' + file.id}>
							<i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip" />
						</a>
					</OverlayTrigger>
				)
			});
			return <div>
				{files}
			</div>
		};

		this.columnModel = [
			{
				name: 'files',
				width: 58,
				sortable:false,
				renderer: rendererFiles
			},
			{
				name: 'title',
				title: 'Název',
				field: 'title',
				renderer: rendererLink
			},
			/*{
				name: 'published',
				title: 'Publ.',
				field: 'published',
				width: 50,
				renderer: Renderers.Check
			},*/
			{
				name: 'groups',
				title: 'Skupiny',
				field: 'groups1',
				width: 240,
				renderer: (val, row) => {
					let s = '';
					if (row.groups1 && row.groups1.length > 0) {
						s += 'I.' + row.groups1;
					}
					if (row.groups2 && row.groups2.length > 0) {
						if (s.length > 0) {
							s += ' | ';
						}
						s += ' II.' + row.groups2;
					}
					return s;
				}
			},
			{
				name: 'fTitle',
				title: 'Složka',
				field: 'fTitle',
				width: 250
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width:80,
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/document/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil"></i> Upravit
						</a>
					);
				}
			}
		];

		const filterSchema = {
			title: { class: FilterInput },
			fulltext: { class: SearchInput },
			fTitle: { class: FolderLookup },
			published: { class: Select, options: DbInfo.YesNo },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
        const sessionState = store.session.get('dg-document');
        // default
        let filter = {};
        // session
        if (sessionState && sessionState.filter) {
            filter = sessionState.filter;
        }
        this.defaultFilter = filter;
        this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'fTitle', 'direction': 'asc'};
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('document.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('document.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('document', row.title, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	getRowClassName(row) {
		return row.line ? 'rowline' : null;
	}

	render() {

		const buttons = <Button href="/document/0" onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nový dokument
		</Button>;

		return (
			<Datagrid
				ref="datagrid"
				id="document"
				api="document.getList"
				buttons={buttons}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={(row) => this.getRowClassName(row)}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Document/List.js